﻿export const AppContainerId = 'veilederlarestederiutlandet';
export const BoksA = 'boks-a';
export const BoksB = 'boks-b';
export const BoksC = 'boks-c';
export const BoksD = 'boks-d';
export const BoksResultatA = 'resultat-a';
export const BoksResultatB = 'resultat-b';
export const BoksEkstraboks = 'ekstraboks';
